<template>
    <div class="bxTjzbhxr">
      <div class="box noBtn">
        <myClock
          :shenyu="shenyu"
          v-if="showTime"
          cId="c1"
          @timeOver="timeOver"
        ></myClock>
        <div class="main">
          <div class="box-btn">
            <el-button
              v-if="shenyu > 0 && shenyu !== ''"
              @click="bjComfirm"
              type="primary"
              :disabled="tjbjState"
              >报价</el-button
            >
          </div>
          <table-tem
            ref="table"
            :config="tableConfig"
            :key="tableConfig.key"
            :span-method="objectSpanMethod"
            :highlightCurrentRow="false"
            @changePage="tableChangePage"
            @changePages="changePages"
          >
          </table-tem>
          <!-- <span class="lf pageNum">此次共有{{zgs}}家投标单位，递交投标报价{{}}家</span> -->
        </div>
      </div>
      <!-- 设置参数 -->
      <el-dialog
        title="查看参数"
        :visible.sync="dialogFormVisible"
        width="580px"
        :close-on-click-modal="false"
      >
        <el-form :model="form" ref="form" :disabled="true" label-position="left">
          <el-form-item
            :label="item.csmc"
            v-for="(item, index) in formItem"
            :key="index"
            :prop="item.csdm"
            :rules="setFormItemRules(item)"
          >
            <el-select
              v-if="item.csdm == 'valueDtype'"
              v-model="form[item.csdm]"
              placeholder="请先选择"
              @focus="selectFocus"
              style="width: 305px"
            >
              <el-option
                v-for="item in dOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="form[item.csdm]"
              :disabled="item.abled"
              @input="defaultValue(item.csdm, form[item.csdm], item.ball)"
              :style="item.csdm == 'zgtbxjkpyt' ? 'width: 230px' : 'width: 200px'"
            ></el-input>
            {{ item.cshz }}
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            @click="saveForm('form')"
            :disabled="waitLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 确认报价 -->
      <el-dialog
        title="确认报价"
        :visible.sync="dialogBjVisible"
        width="1200px"
        :close-on-click-modal="false"
      >
        <el-form ref="inventoryForm" :model="inventoryForm" size="small">
          <el-table
            :data="inventoryForm.dataList"
            style="width: 100%"
            highlight-current-row
          >
            <el-table-column
              label="序号"
              width="55"
              type="index"
            ></el-table-column>
            <el-table-column
              v-for="item in titleListData"
              :key="item.id"
              :label="item.cszmc"
              width="250"
            >
              <template slot-scope="scope">
                <el-form-item
                  v-if="item.cszlx == 1"
                  style="min-width: 150px"
                  :prop="`dataList.${scope.$index}.${item.id}`"
                  :rules="{
                    required: item.cszly == 2 ? true : false,
                    message: `请输入${item.cszmc}`,
                    trigger: 'blur',
                  }"
                >
                  <el-input
                    v-model="scope.row[item.id]"
                    :disabled="item.cszly != 2"
                    placeholder="请输入内容"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  v-else
                  style="min-width: 120px"
                  :prop="`dataList.${scope.$index}.${item.id}`"
                  :rules="{
                    required: item.cszly == 2 ? true : false,
                    message: `请输入${item.cszmc}`,
                    trigger: 'blur',
                  }"
                >
                  <el-input
                    v-model="scope.row[item.id]"
                    @input="handleInput(scope.row, item.id, item)"
                    :disabled="item.cszly != 2"
                    :placeholder="item.cszly == 3 ? '系统自动计算' : '请输入数值'"
                    clearable
                  ></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            @click="saveInvent('form')"
            :disabled="waitLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- <div v-else class="loading">
      <p>页面正在加载中...</p>
      <div id="colorfulPulse">
        <span class="item-1"></span>
        <span class="item-2"></span>
        <span class="item-3"></span>
        <span class="item-4"></span>
        <span class="item-5"></span>
        <span class="item-6"></span>
        <span class="item-7"></span>
      </div>
    </div> -->
  </template>
    
    <script>
  import tableTem from "@/components/tableTem/index.vue";
  import myClock from "@/components/clock/clock";
  export default {
    components: {
      myClock,
      tableTem,
    },
    computed: {
      role() {
        return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
      },
    },
    data() {
      return {
        waitLoading: false,
        djlcId: "", //节点流程id
        kbxmlc: {},
        tableConfig: {
          head: [],
          data: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          border: true,
          key: 1
        },
        options: [
          {
            value: 1,
            label: "按投标单位自动推荐最低价",
          },
          {
            value: 2,
            label: "按条目自动推荐最低价",
          },
        ],
        tjzbhxr: null,
        tableData: [],
        number: [],
        dialogVisible: false,
        dialogFormVisible: false, //设置参数
        dscbDialogVisible: false, //电声唱标
        candidate: null,
        candidateOptions: [],
        tbdwmc: "",
        multipleSelection: [], // 表格选择
        dsForm: {
          volume: 1,
          rate: 1,
        },
        synth: "", //对象
        msg: "", //实例
        isStop: false, //是否暂停电声状态
        isStart: false,
        text: [], //电声内容
        csjg: "", // 是否已经设置过参数
        num: 0,
        form: {},
        formItem: [],
        kbxm: {},
        shenyu: "",
        showTime: false,
        qdlist: [],
        length: 0,
        dialogBjVisible: false,
        inventoryForm: {
          dataList: [],
        },
        titleListData: [],
        tjbjState: false,
      };
    },
    created() {
      this.djlcId = this.$route.query.djlcId;
      this.tjzbhxr = 1;
      this.$nextTick(() => {
        this.getData();
      });
    },
    methods: {
      async checkPriceState() {
        try {
          const res = await this.$api.checkPriceState(this.kbxm.bjcs);
          if (res.data.success) {
            this.tjbjState = res.data.data;
          }
        } catch (error) {
          this.$message.error(error.data.msg);
        }
      },
      saveInvent() {
        this.$refs.inventoryForm.validate(async (valid) => {
          if (valid) {
            this.submitMethod();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      // 保存方法
      async submitMethod() {
        // [[第一行数据]，[第二行数据]。。。]（后端获取的数据）
        this.qdlist.map((item) => {
          // 循环获取每一行数据
          item.map((ite) => {
            // 循环获取每一列数据
            // [{对应的key：对应的value}。。。]（表格所填的数据）
            this.inventoryForm.dataList.forEach((it) => {
              // 循环获取每一个对象
              if (ite.bjqdId == it.bjqdId) {
                // 每一行数据的清单id对应上表格所填数据的清单id
                Object.keys(it).forEach((i) => {
                  // 获取表格所填数据的key
                  if (i == ite.bjcsId) {
                    // 对应上的赋值
                    ite.csznr = it[i];
                  }
                });
              }
            });
          });
        });
        let list = [];
        this.qdlist.map((item) => {
          item.map((ite) => {
            list.push(ite);
          });
        });
        let para = {
          bdId: this.kbxm.fgbdid,
          bjcs: this.kbxm.bjcs,
          dataList: list,
        };
        try {
          const res = await this.$api.tbdwSave(para);
          if (res.data.code == 200) {
            this.$message.success("保存成功");
            this.dialogBjVisible = false;
            this.getData();
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
          }
        } catch (err) {
          this.$message.error(err.data.msg);
          console.log("debug", err);
        }
      },
      bjComfirm() {
        this.tbbjcsList();
        this.tbbjcsQdlist();
        this.dialogBjVisible = true;
      },
      // 清单列表
      async tbbjcsQdlist() {
        let para = {
          bdId: this.kbxm.fgbdid,
        };
        try {
          const res = await this.$api.tbbjcsQdlist(para);
          if (res.data.code == 200) {
            this.qdlist = res.data.data;
            this.length = res.data.data[0]?.length;
            let arr = res.data.data.map((item) => {
              let obj = {};
              item.forEach((ite) => {
                obj[ite.bjcsId] = ite.csznr;
                obj.bjqdId = ite.bjqdId;
              });
              return obj;
            });
            this.inventoryForm.dataList = arr;
          }
        } catch (err) {
          console.log("debug", err);
        }
      },
      // 参数列表
      async tbbjcsList() {
        let para = {
          bdId: this.kbxm.fgbdid,
        };
        try {
          const res = await this.$api.tbbjcsList(para);
          if (res.data.code == 200) {
            this.titleListData = res.data.data;
          }
        } catch (err) {
          this.$message.error(err.response?.data.message || err.message);
          console.log("debug", err);
        }
      },
      handleInput(row, field, item) {
        console.log(row, "----", item);
        // 可以在这里添加对输入的处理逻辑
        // 例如，处理非数字输入
        if (isNaN(row[field])) {
          row[field] = null; // 或者保持原来的数值
        }
        if (row[field] > Number(item.xzsrfwxy)) {
          row[field] = Number(item.xzsrfwxy);
        }
        // 或者限制小数位数
        if (row[field].indexOf(".") > 0) {
          row[field] = row[field].slice(
            0,
            row[field].indexOf(".") + item.xsdhblws + 1
          );
        }
      },
      timeOver() {
        this.showTime = false;
        this.getData();
      },
      searchData() {
        let obj = {
          tbdwmc: this.tbdwmc,
        };
        this.getData(obj);
      },
      //保存参数设置
      saveForm(formName) {
        this.dialogFormVisible = false;
      },
      /**
       * 设置表单校验规则
       * @param formItem
       */
      setFormItemRules(formItem) {
        // 预设x、y值的校验函数
        let validatorObj = {
          x: (rule, value, callback) => {
            if (!/^[0-9]$/.test(value)) {
              return callback(new Error("x值的取值范围为0-9的整数"));
            } else {
              callback();
            }
          },
          y: (rule, value, callback) => {
            if (!/^[0-9]$/.test(value)) {
              return callback(new Error("y值的取值范围为0-9的整数"));
            } else {
              callback();
            }
          },
        };
        // 预设x、y值的校验规则
        let ruleX = [{ validator: validatorObj.x, trigger: "change" }];
        let ruleY = [{ validator: validatorObj.y, trigger: "change" }];
  
        let rules = /^[a-z]$/g.test(formItem.csdm)
          ? [{ validator: this.validateFieldMethods, trigger: "blur" }]
          : formItem.csdm == "cqxfl"
          ? []
          : [{ required: true, message: "必填项", trigger: "blur" }];
        // x值
        if (formItem.csdm === "xkpyt") {
          rules = rules.concat(ruleX);
        }
        // y值
        if (formItem.csdm === "ykpyt") {
          rules = rules.concat(ruleY);
        }
        return rules;
      },
    
      changeData(secondaryName, threeLevelName) {
        this.tableConfig.data = [];
        this.number = [];
        this.companyFlag = false;
        for (const v of this.tableData) {
          v[secondaryName].map((k, index) => {
            k[threeLevelName].map((p, index) => {
              k[p.bjcsId] = p.csznr;
            });
          });
        }
        for (const v of this.tableData) {
          v[secondaryName].map((k, index) => {
            let param = {
              ...v,
              qdmc: this.tjzbhxr == 1 ? k.qdmc : v.qdmc,
              qymc: this.tjzbhxr == 1 ? v.qymc : k.qymc,
              ...k,
            };
            this.tableConfig.data.push(param);
          });
        }
        for (let i = 0; i < this.tableData.length; i++) {
          this.number.push({
            qdmc: this.tableData[i].qdmc,
            num: this.tableData[i][secondaryName].length,
          });
        }
        let msgIndex = 0;
        let msgArr = [];
        for (let i = 0; i < this.number.length; i++) {
          let num = this.number[i].num;
          msgIndex += num;
          msgArr.push(msgIndex);
        }
        msgArr.pop();
        msgArr.unshift(0);
        for (let i = 0; i < this.number.length; i++) {
          let num = this.number[i].num;
          this.tableConfig.data[msgArr[i]].rowspan = num;
        }
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // 如果是前两列，就使用idIndex数据来进行合并
        if (this.tjzbhxr == 1) {
          if ([0, 1, 2].includes(columnIndex)) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        } else {
          if (columnIndex <= 2) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        }
      },

      getData(data) {
        this.once();
        this.$refs.table.$refs.tableTem.clearSelection();
        this.candidate = null;
        let para = {
          djlcId: this.djlcId,
          currentPage: this.tableConfig.currentPage,
          type: this.tjzbhxr,
          pageSize: this.tableConfig.pageSize,
        };
        para = Object.assign(para, data);
        this.waitLoading = true;
        this.$api
          .getDcbjList(para)
          .then((res) => {
            if (res.data.meta.success) {
              let cgTbbjCsList = res.data.data.cgTbbjCsList || [];
              cgTbbjCsList.map((item, index) => {
                this.tableConfig.head.splice(3 + index, 0, {
                  key: item.id,
                  title:
                    item.cszmc + (item.bjlxdw ? "(" + item.bjlxdw + ")" : ""),
                  align: "center",
                });
              });
              this.csjg = res.data.data.csList;
              this.tableData = res.data.data.tbdwList.list;
              this.tableConfig.total = res.data.data.total;
              // this.bjgs = res.data.data.bjgs
              // this.zgs = res.data.data.zgs
              this.kbxmlc = res.data.data.kbxmlc;
              this.kbxm = res.data.data.kbxm;
              this.shenyu =
                new Date(this.kbxm.dcbjQrsj).getTime() - new Date().getTime();
              if (this.shenyu > 0) {
                this.showTime = true;
              } else {
                this.showTime = false;
              }
              this.checkPriceState();
              this.tableConfig.key++;
              this.changeData("tbdwQdTbdwResultList", "tbdwCsTbdwResultList");
            } else {
              this.$message({
                type: "error",
                message: res.data.meta.message,
              });
            }
            this.waitLoading = false;
          })
          .catch(() => {});
      },
      init() {
        this.msg = new SpeechSynthesisUtterance();
        let _this = this;
        this.msg.onend = function () {
          //唱完了
          if (_this.num == _this.text.length - 1) {
            _this.synth.cancel(_this.msg);
            _this.num = 0;
            _this.$refs.table.$refs.tableTem.setCurrentRow();
          } else {
            _this.num++;
            _this.handleSpeak();
          }
          _this.isStart = false;
        };
        this.msg.onstart = function () {
          _this.isStart = true;
        };
      },
      once() {
        this.tableConfig.head = [
          {
            key: "xh",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "qymc",
            title: "投标单位名称",
            align: "center",
          },
        ];
      },
      dialogShow() {
        console.log(this.$refs.table.checkList);
        const list = this.$refs.table.checkList;
        if (list.length == 1) {
          this.dialogVisible = true;
        } else {
          this.$message.warning("请勾选1家投标单位");
        }
      },
      bxNextBtn() {
        if (this.csjg.length == 0) {
          if (this.showGz) {
            this.$message.error("请设置参数！");
          } else {
            this.$confirm(
              "您还未设置参数，请确认该项目无参数需要设置！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                let para = {
                  flag: this.kbxmlc.ycdz,
                };
                this.waitLoading = true;
                this.$emit("nextBtn", para);
              })
              .catch(() => {});
          }
        } else if (this.isStart) {
          this.$confirm("请确认是否结束电声唱标，并进入下一步！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let para = {
                flag: this.kbxmlc.ycdz,
              };
              this.waitLoading = true;
              this.$emit("nextBtn", para);
            })
            .catch(() => {});
        } else {
          let para = {
            flag: this.kbxmlc.ycdz,
          };
          this.waitLoading = true;
          this.$emit("nextBtn", para);
        }
      },
      // 分页功能
      tableChangePage(e) {
        this.tableConfig.currentPage = e;
        this.getData();
      },
      changePages(e) {
        this.tableConfig.pageSize = e;
        this.getData();
      },
    },
  };
  </script>
    
    <style lang='scss' scoped>
  ::v-deep .el-form-item {
    margin-bottom: 0px !important;
  }
  .main {
    .main-top {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      .main-top-left {
        margin-bottom: 10px;
        label {
          margin-right: 20px;
        }
      }
    }
    .rightButton {
      position: absolute;
      right: 10px;
      top: 60px;
    }
  }
  .box-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .clear {
    clear: initial !important;
  }
  .pageNum {
    position: relative;
    bottom: 50px;
  }
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: white;
  }
  </style>
    